import { Cancel } from "@material-ui/icons";
import React from 'react';
import styled from 'styled-components';

const FileClear = styled.button`
  background: transparent;
  border: 0;
  padding: 0;
  margin-bottom: 0.2rem;
  margin-left: 0.2rem;

  &:hover {
    background: transparent !important;
    color: transparent;
  }

  &:focus {
    outline: 0;
  }

`;

const CustomCancel = styled(Cancel)`
  &&& {
    width: 1rem;
    height: 1rem;
    fill: ${({theme}) => theme.palette.gray.main};

    &:hover {
      fill: red;
    }
  }
`;

const ClearFile = (props) => (
    <FileClear {...props}>
        <CustomCancel />
    </FileClear>
);

export default ClearFile;